import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { useMemo } from "react";

ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend);

const labels = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];

// Transforme les dates en compte par jour de la semaine (Lun, Mar, ...)
const generateTrendByDayName = (interactions = []) => {
  const trend = Array(7).fill(0); // Lundi=0 ... Dimanche=6

  interactions.forEach(({ date }) => {
    const d = new Date(date);
    const dayIndex = d.getDay() === 0 ? 6 : d.getDay() - 1; // JS: 0=Dimanche, 1=Lundi ...
    trend[dayIndex] += 1;
  });

  return trend;
};

const ArticleTrendChart = ({ article, activeMetric }) => {
  console.log("ArticleTrendChart", article, activeMetric);
  const metrics = useMemo(
    () => ({
      vues: { label: "Vues", color: "#3498db", data: article.nbVue || 0 },
      favoris: { label: "Favoris", color: "#cc2e2e", data: article.nbFavoris || 0 },
      messages: { label: "Messages", color: "#9b59b6", data: article.nbMessage || 0 },
      appels: { label: "Appels", color: "#1baebe", data: article.nbAppel || 0 },
      whatsApp: { label: "WhatsApp", color: "#1bbe3e", data: article?.nbWhatsapp || 0 },
    }),
    [article]
  );

  const metric = metrics[activeMetric];
  const trend = generateTrendByDayName(metric.data);

  const data = {
    labels,
    datasets: [
      {
        label: metric.label,
        data: trend,
        borderColor: metric.color,
        backgroundColor: metric.color + "33",
        fill: true,
        tension: 0.3,
        pointRadius: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: true },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.parsed.y} ${metric.label}`,
        },
      },
    },
    scales: {
      y: { beginAtZero: true },
    },
  };

  return (
    <div className="article-chart">
      <h4>{metric.label} par jour de la semaine</h4>
      <Line data={data} options={options} />
    </div>
  );
};

export default ArticleTrendChart;
